export const CATEGORY_META = {
  "Food & Drink": { icon: "UtensilsCrossed", color: "from-orange-500/90 to-amber-600/90" },
  "Home/Car Services": { icon: "Car", color: "from-slate-700/90 to-slate-900/90" },
  "Beauty": { icon: "Scissors", color: "from-pink-500/90 to-rose-600/90" },
  "Shopping": { icon: "ShoppingBag", color: "from-violet-500/90 to-purple-700/90" },
  "Events": { icon: "PartyPopper", color: "from-fuchsia-500/90 to-pink-600/90" },
  "Hidden Gems": { icon: "Gem", color: "from-teal-500/90 to-emerald-700/90" },
  "Health & Wellness": { icon: "HeartPulse", color: "from-emerald-500/90 to-green-700/90" },
  "Local Markets": { icon: "Store", color: "from-amber-500/90 to-orange-600/90" },
};

export const CATEGORY_IMAGES = {
  "Food & Drink": "https://images.unsplash.com/photo-1568485085630-337cf2d871ca?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "Home/Car Services": "https://images.unsplash.com/photo-1486006920555-c77dcf18193c?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "Beauty": "https://images.unsplash.com/photo-1762745101365-1dbc90b98007?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "Shopping": "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "Events": "https://images.unsplash.com/photo-1645976442233-bcf005876613?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "Hidden Gems": "https://images.unsplash.com/photo-1559811814-e2c57b5e69df?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "Health & Wellness": "https://images.unsplash.com/photo-1676496962536-d8ef110ff6f0?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "Local Markets": "https://images.unsplash.com/photo-1526399743290-f73cb4022f48?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
};

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_hidden-finds-1/artifacts/v18wbpt9_image-2.png";

export const PLACEHOLDER_IMAGE = "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&q=80&w=800";

export function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - then);
  const m = Math.floor(diff / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  const w = Math.floor(d / 7);
  if (w < 5) return `${w}w ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good Morning";
  if (h < 17) return "Good Afternoon";
  return "Good Evening";
}
